import styled from 'styled-components';
import { respondTo } from '../../common/styles/mixins';
import * as colors from '../../common/styles/colors';

export const ScheduledReportModalWrapper = styled.div`
  .modal-title {
    color: ${colors.hydroBlue};
  }

  .rmdp-input {
    height: 40px;
  }

  .consentLink {
    color: ${colors.hydroBlue};
  }
`;

export const ScheduledReportWrapper = styled.div`
  padding: 0 1rem 1rem;

  ${respondTo.tablet`
    margin: 0;
    padding: 0 33px 33px 0;
  `}

  .static-text {
    text-align: center;

    ${respondTo.tablet`
        text-align: left;
      `};
  }
`;

export const ScheduledReportGridWrapper = styled.div``;
